import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useStyles } from './ShippingPage.styles'
import {
  Grid,
  Card,
  Typography,
  Radio,
  Box,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material/'
import BottomActions from '../../components/BottomActions'
import Title from '../../components/Title'
import { createHeaderCart } from './services/createHeaderCart'
import { formatDate } from 'utils/formatDate'
import CheckoutSummary from 'components/CheckoutSummary/CheckoutSummary'

import { selectCurrentBranch } from 'stores/userStore/actionsUser'
import getTransports from './services/getTransports'
import { setSnackbar } from 'stores/snackbarStore'
import LoadingSpinner from 'components/LoadingSpinner'
import { fixAmount } from 'pages/ProductPage/utils/helpers'
import { Helmet } from 'react-helmet'
import { getCartSummary } from 'components/CheckoutSummary/helpers/helpers'
import InputBase from '@mui/material/InputBase'

const currentDate = formatDate(true)

const idOrder = formatDate()
const ShippingPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const cart = useSelector((state) => state.cart)
  const { userInfo, currentBranch } = useSelector(({ userAuth }) => userAuth)
  const classes = useStyles()
  const desktop = useMediaQuery((theme) => theme.breakpoints.up('sm'))
  const [inputSearch, setInputSearch] = useState('')
  // STATE
  const [shippingMethod, setShippingMethod] = useState('')
  const [shippingMethodList, setShippingMethodList] = useState([])
  const [loading, setLoading] = useState(false)
  const [fetchingTransports, setFetchingTransports] = useState(false)

  const summaryValues = useMemo(() => getCartSummary(cart), [cart])

  const checkoutHandler = async () => {
    if (shippingMethod) {
      if (!currentBranch?.openedCart) {
        dispatch(selectCurrentBranch({ ...currentBranch, openedCart: idOrder }))
        const localData = localStorage.getItem('userInfo')
        const localBranchData = JSON.parse(localData)?.sucursales
        const sucursales = localBranchData?.map((branch) => {
          if (branch?.cod === currentBranch?.cod)
            return { ...currentBranch, openedCart: idOrder }
          return branch
        })
        localStorage.setItem(
          'userInfo',
          JSON.stringify({ ...JSON.parse(localData), sucursales })
        )
      }

      setLoading(true)
      try {
        const isSellerUser = localStorage.getItem('permisos') === '2'
        const { message } = await createHeaderCart({
          totalAmount: fixAmount(summaryValues?.total || 0),
          finalUserAmount: fixAmount(summaryValues?.total || 0),
          cardCode: userInfo.codigoUsuario,
          idUsuario: userInfo.codigoUsuario,
          uNroCompEsp: `${userInfo.codigoUsuario}${cart.idOrder}`,
          slpCode: currentBranch?.slpCode,
          idOrder: cart.idOrder,
          uBitSucursal: currentBranch?.cod,
          uBitTransporteAsignado: shippingMethod,
          docDate: currentDate,
          docDueDate: currentDate,
          discPrcnt: summaryValues?.cupon?.percentage || '0',
          discCode: summaryValues?.cupon?.code || '',
          uBitOrigenPedido: isSellerUser ? '11' : '8',
          groupNum: userInfo.codPago
        })
        if (message.match(/exito/i)) {
          navigate('/finalizar-compra')
        }
      } catch (error) {
        dispatch(
          setSnackbar(
            true,
            'error',
            'Error de conexion. Vuelva a intentarlo mas tarde.'
          )
        )
      }
      setLoading(false)
    } else {
      dispatch(
        setSnackbar(
          true,
          'warning',
          'Por favor, elija un transporte antes de continuar.'
        )
      )
    }
  }
  const handleChange = (e) => setShippingMethod(e.target.value)

  const handleShippingMethod = (shippingMethod) =>
    setShippingMethod(shippingMethod)

  const goToHome = () => navigate('/')

  // USE EFFECT
  useEffect(async () => {
    // Cargar transportes
    if (currentBranch.cod) {
      try {
        setShippingMethodList([])
        setFetchingTransports(true)
        const res = await getTransports(currentBranch.cod)
        if (res) {
          if (res.length > 5) {
            setShippingMethodList(res)
          } else {
            setShippingMethodList(res)
          }
        } else {
          dispatch(setSnackbar(true, 'error', 'Error al cargar transportes'))
        }
      } catch (error) {
        dispatch(setSnackbar(true, 'error', 'Error al cargar transportes'))
      }
      setFetchingTransports(false)
    }
  }, [currentBranch])

  return (
    <>
      <Helmet>
        <title>Opciones de envío | Villanueva</title>
        <meta name='description' content='Elige tu opción de envío' />
        <meta
          name='keywords'
          content='envío, envío villanueva, retiro, despacho, transporte'
        />
      </Helmet>
      <Box className={classes.container}>
        <Box className={classes.titleContainer}>
          <Title
            text='Opciones de envío'
          />
          <InputBase
            placeholder="Filtrar resultados"
            inputProps={{
              style: { borderBottom: '1px solid #bebebe', borderRadius: 0, padding: 2, marginRight: 20 },
              disableUnderline: true
            }}
            onChange={(e) => setInputSearch(e.target.value)}
          />
        </Box>
        <Grid container className={classes.innerContainer}>
          <Box className={classes.shippingMethods}>
            {[
              {
                title: 'Retiro en Sucursal',
                value: currentBranch?.cod,
                description: currentBranch?.name,
                codigo: 'Retiro en sucursal',
              },
              ...shippingMethodList,
            ]
            .filter((item) => 
              [item?.title, item?.description, item?.codigo]
                .some((field) => field?.toLowerCase()?.includes(inputSearch.toLowerCase())) 
            )
            .map((item, index) => (
              <Card
                className={classes.card}
                onClick={() => handleShippingMethod(item.value)}
                key={index}
              >
                <Grid container className={classes.cardInsideContainer}>
                  <FormControlLabel
                    control={
                      <Radio
                        sx={{ margin: '0px 14px' }}
                        checked={shippingMethod === item.codigo}
                        onChange={handleChange}
                        value={item.codigo}
                      />
                    }
                    label={
                      <Grid>
                        <Typography className={classes.addressTitleActive}>
                          {item.title || 'Despacho por transporte'}
                        </Typography>
                        <Typography
                          className={classes.addressDescriptionActive}
                        >
                          {item.description || item.codigo}
                        </Typography>
                      </Grid>
                    }
                  />
                </Grid>
              </Card>
            ))}
            {fetchingTransports && <LoadingSpinner />}
          </Box>

          {desktop ? (
            <CheckoutSummary
              firstAction={checkoutHandler}
              secondAction={goToHome}
              firstActionDisabled={loading}
              firstText={'Proceder al Pago'}
              secondText={'Seguir comprando'}
            />
          ) : (
            <Grid className={classes.grid}>
              <BottomActions
                cart={cart}
                firstAction={checkoutHandler}
                firstActionDisabled={loading}
                secondAction={goToHome}
                firstText={'Proceder al Pago'}
                secondText={'Seguir comprando'}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  )
}

export default ShippingPage
